export default __webpack_public_path__ + "static/media/default-user.94cf7531.png";